module.exports = __webpack_public_path__ + "img/icon-message-flame.6e0c1071.svg";